import store from "store";

export const saveStoreValue = (value: number) => {
    if (!process.env.WEBPACK) return;
    store.set("supportWarning", value.toString());
};

export const getStoreValue = () => {
    if (!process.env.WEBPACK) return;
    return +(store.get("supportWarning") || 0);
};
